import { connect } from 'react-redux';
import * as resumeActions from 'redux-modules/resume/actions.js';
import * as resumeSelectors from 'redux-modules/resume/selectors.js';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import ExecutiveSummary from './ExecutiveSummary';

function mapStateToProps(state) {
  return {
    executiveSummary: resumeSelectors.selectExecutiveSummary(state),
    language: uiStateSelectors.selectResumeLanguage(state),
    syncErrors: resumeSelectors.selectSyncError(state),
    syncing: resumeSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSave: (data, failCallback) => dispatch(resumeActions.saveExecutiveSummary(data, failCallback))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummary);
